import trainingCourseRepository from "../../../../infrastructure/repository/impl/training-course/training_course_repository";
import TrainingCourseInterface from "./trainingCorseInterface";
import { TrainingCourseRequest } from "../../../entities/courseEvent/training_course";
import { Instructor } from "../../../entities/entities";

class TrainingCourseUseCases implements TrainingCourseInterface {
  async get(id: number): Promise<TrainingCourseRequest> {
    return await trainingCourseRepository.get(id);
  }

  async getInstructors(id: number): Promise<Instructor[]> {
    return await trainingCourseRepository.getInstructors(id);
  }
  async enroll(id: number): Promise<void> {
    return await trainingCourseRepository.enroll(id);
  }

  async unenroll(id: number): Promise<void> {
    return await trainingCourseRepository.unenroll(id);
  }
  async confirmCheckinQrCode(token: string, id: number): Promise<void> {
    return await trainingCourseRepository.confirmCheckinQrCode(token, id);
  }
}

export default new TrainingCourseUseCases() as TrainingCourseInterface;
